// src/Api/profileApi.js
import { get } from "./api";

// ✅ Fetch user profile
export const fetchUserProfile = async () => {
  try {
    const response = await get("/profile");
    console.log("Fetched Profile Data:", response);
    return response;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw error;
  }
};

// Optional: export as default
export default {
  fetchUserProfile,
};
